export const roleDestination = (role) => {
  if (role === "bank_admin") return "/mantab";
  if (role === "bank_operator") return "/mantab/kelola-distribusi";
  return "/padma";
};